import React from "react";
import ComparisonResults from "./ComparisonResults";

const RunResults: React.FC = () => <ComparisonResults />;

export default RunResults;